import * as joint from '@joint/plus';

export function initializeToolsAndInspector(service) {
  const { paper, graph, selection, inspectorService } = service;

  paper.on('cell:pointerup', (cellView) => {
    if (inspectorService.isSelectingDestination) return;
    const cell = cellView.model;
    if (!selection.collection.includes(cell)) {
      selection.collection.reset([cell]);
    }
  });

  paper.on('blank:pointerdown', () => {
    selection.collection.reset([]);
    inspectorService.inspector?.remove();
    if (!service.readOnly) {
      graph.getCells().forEach((cell) => {
        if (cell.isLink()) {
          const view = paper.findViewByModel(cell);
          view?.removeTools();
        }
      });
    }
  });

  graph.on('change', (cell, opt) => {
    if (!(cell.isLink && opt.inspector)) return;
    if (service.readOnly) return;
    const view = cell.findView(service.paper);
    if (view && !view.hasTools('link-tools')) {
      const ns = joint.linkTools;
      view.addTools(
        new joint.dia.ToolsView({
          name: 'link-inspected',
          tools: [new ns.Boundary({ padding: 15 })],
        })
      );
    }
  });

  paper.on('link:pointerdown', (linkView, evt) => {
    evt.stopPropagation();
    const link = linkView.model;
    if (service.readOnly) return;
    if (!linkView.hasTools('link-tools')) {
      graph.getLinks().forEach((other) => {
        if (other !== link) {
          service.paper.findViewByModel(other)?.removeTools();
        }
      });
      service.selectPrimaryLink(linkView);
    }
    link.set('interactive', {
      vertexAdd: true,
      vertexMove: true,
      vertexRemove: true,
      arrowheadMove: true,
      labelMove: true,
      useLinkTools: true,
      addVertex: true,
      removeVertex: true,
    });
  });
}
